<template>
  <div>
    <div class="checkbox check-primary">
      <input type="checkbox"
             :id="checkboxId"
             :checked="!noValue"
             @change="updateFilterState">
      <label :for="checkboxId"></label>
    </div>
    <div v-if="!noValue">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      //filter value
      value: {
        type: null,
        required: true
      },
      //see computed and updateFilterState
      initialValues: {
        type: Array,
        default: () => []
      },
      initialValue: {
        type: String,
        default: () => ""
      }
    },

    computed: {
      noValue () {
        return this.isSelectFilter? _.isEmpty(this.value) : _.isNil(this.value)
      },
      isMultipleOptionsFilter () {
        return !!this.initialValues.length
      },
      isOptionFilter () {
        return !!this.initialValue.length
      },
      isSelectFilter () {
        return this.isMultipleOptionsFilter || this.isOptionFilter
      },
      checkboxId () {
        return _.uniqueId('checkbox_')
      }
    },

    methods: {
      updateFilterState (event) {
        const checked = event.target.checked
        this.$emit('update:filter', this.determineSelectValue(checked) || checked || null)
      },

      determineSelectValue (checked) {
        if (checked) {
          if (this.isMultipleOptionsFilter)
            return this.initialValues
          else if (this.isOptionFilter)
            return this.initialValue
        } else {
          if (this.isMultipleOptionsFilter)
            return []
          else if (this.isOptionFilter)
            return ""
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// client/components/CustomersList/SearchFilterWrapper.vue